// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_originSection__9BEv8 {
  background-color: var(--background-color0);
  padding: 6rem 0;
}

.styles_originGrid__jfISJ {
  display: grid;
  grid-template-columns: 0.9fr 1.1fr;
  gap: 4rem;
  align-items: center;
}

@media (max-width: 900px) {
  .styles_originGrid__jfISJ {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
}

.styles_imageWrapper__JhvUo {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
}

.styles_sectionImage__DH15B {
  max-width: 100%;
  height: auto;
  border-radius: 1.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  transition: transform 0.4s ease;
}

.styles_sectionImage__DH15B:hover {
  transform: scale(1.02);
}

.styles_textContainer__zGtEu {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.styles_sectionTitle__nxwCl {
  font-size: 2.2rem;
  font-weight: 700;
  text-align: left;
  color: var(--text-color0);
  margin-bottom: 1rem;
}

.styles_divider__WYsCN {
  width: 5rem;
  height: 4px;
  background-color: var(--brand-yellow);
  border: none;
  border-radius: 2px;
  margin: 1rem 0 2rem 0;
}

.styles_subtitle__j6iMY {
  font-size: 1.3rem;
  font-weight: 800;
  color: var(--brand-yellow);
  letter-spacing: 0.08rem;
  margin: 0;
  text-transform: uppercase;
}

.styles_descText__QOER0 {
  font-size: 1.15rem;
  color: var(--text-color1);
  line-height: 1.7;
  margin: 0;
}

.styles_goldHighlight__\\+6QND {
  color: var(--brand-yellow);
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/pages/public/CadastroLoja/components/OriginSection/styles.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB","sourcesContent":[".originSection {\n  background-color: var(--background-color0);\n  padding: 6rem 0;\n}\n\n.originGrid {\n  display: grid;\n  grid-template-columns: 0.9fr 1.1fr;\n  gap: 4rem;\n  align-items: center;\n}\n\n@media (max-width: 900px) {\n  .originGrid {\n    grid-template-columns: 1fr;\n    gap: 3rem;\n  }\n}\n\n.imageWrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  position: relative;\n}\n\n.sectionImage {\n  max-width: 100%;\n  height: auto;\n  border-radius: 1.5rem;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  transition: transform 0.4s ease;\n}\n\n.sectionImage:hover {\n  transform: scale(1.02);\n}\n\n.textContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.sectionTitle {\n  font-size: 2.2rem;\n  font-weight: 700;\n  text-align: left;\n  color: var(--text-color0);\n  margin-bottom: 1rem;\n}\n\n.divider {\n  width: 5rem;\n  height: 4px;\n  background-color: var(--brand-yellow);\n  border: none;\n  border-radius: 2px;\n  margin: 1rem 0 2rem 0;\n}\n\n.subtitle {\n  font-size: 1.3rem;\n  font-weight: 800;\n  color: var(--brand-yellow);\n  letter-spacing: 0.08rem;\n  margin: 0;\n  text-transform: uppercase;\n}\n\n.descText {\n  font-size: 1.15rem;\n  color: var(--text-color1);\n  line-height: 1.7;\n  margin: 0;\n}\n\n.goldHighlight {\n  color: var(--brand-yellow);\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"originSection": `styles_originSection__9BEv8`,
	"originGrid": `styles_originGrid__jfISJ`,
	"imageWrapper": `styles_imageWrapper__JhvUo`,
	"sectionImage": `styles_sectionImage__DH15B`,
	"textContainer": `styles_textContainer__zGtEu`,
	"sectionTitle": `styles_sectionTitle__nxwCl`,
	"divider": `styles_divider__WYsCN`,
	"subtitle": `styles_subtitle__j6iMY`,
	"descText": `styles_descText__QOER0`,
	"goldHighlight": `styles_goldHighlight__+6QND`
};
export default ___CSS_LOADER_EXPORT___;
